var _ = require('underscore');
var $ = require('jquery');
var TorsoService = require('backbone-torso/modules/ServiceCell');
var enumerationExtService = require('./../urls').enumerationExtService;

/**
 * Service that manages the list of enumerations.
 *
 * @class enumerationListService
 * @constructor
 */
module.exports = new (TorsoService.extend({
  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    _.bindAll(this, 'fetch', '_saveList');
  },

  /**
   * Sets the listName.
   *
   * @method setListName
   * @param {String} listName
   */
  setListName: function(listName) {
    this.set('listName', listName);
  },

  /**
   * Fetches and saves the fetched enumeration list on this service.
   * @method fetch
   * @param {String} listName the name of the list to fetch.
   * @return {jQuery.Deferred} that is returned from the fetch of the list.
   */
  fetch: function (listName) {
    this.setListName(listName);
    return $.ajax({
      url: enumerationExtService + '/' + listName,
      contentType: 'application/json',
      type: 'GET'
    }).then(this._saveList);
  },

  /**
   * @method _saveList
   * @param list {String[]} array of all options for the given listName.
   * @private
   */
  _saveList: function(list) {
    var listName = this.get('listName');
    this.set(listName, list);
  }
}))();
